export default {
  CLEAN_LIST: Symbol('CLEAN_LIST'),
  TOGGLE_LOADING: Symbol('TOGGLE_LOADING'),
  SET_SEARCH_VALUE: Symbol('SET_SEARCH_VALUE'),
  RESET_PAGINATION: Symbol('RESET_PAGINATION'),
};
